/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
}
:host .labels {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host .labels .headline {
  padding-bottom: calc(8rem /14);
  margin-right: calc(40rem /14);
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
  font-size: calc(14rem /14);
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  border-bottom: 2px solid transparent;
}
:host .labels .headline davinci-icon {
  height: calc(24rem /14);
  width: calc(24rem /14);
  fill: #50585C;
  fill: var(--davinci-color-text-light, #50585C);
}
:host .labels .headline .label {
  line-height: calc(24rem /14);
}
:host .labels .headline:hover {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}
:host .labels .headline:hover davinci-icon {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}
:host .labels .headline:focus {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}
:host .labels .headline:focus davinci-icon {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}
:host .labels .headline[selected] {
  border-bottom: 2px solid var(--davinci-color-primary,#007CC1);
}
:host .headline[disabled] {
  pointer-events: none;
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host .headline[disabled] davinci-icon {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host .tabs {
  height: 100%;
}

:host([type=classic]) .labels .headline {
  min-width: calc(120rem /14);
  margin: 0 1px;
  border: none;
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
  padding: 0 calc(20rem /14);
  font-size: calc(14rem /14);
  line-height: calc(24rem /14);
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}
:host([type=classic]) .labels .headline .label {
  margin: 0px calc(8rem /14);
  line-height: calc(36rem /14);
}
:host([type=classic]) .labels .headline .custom-icon {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host([type=classic]) .labels .headline .close {
  height: calc(18rem /14);
  width: calc(18rem /14);
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
  margin-left: auto;
}
:host([type=classic]) .labels .headline .close:hover {
  fill: var(--davinci-color-white, );
  background-color: #B1B8BC;
  background-color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([type=classic]) .labels .headline:hover {
  color: #2C3133;
  color: var(--davinci-color-text-on-background-3, #2C3133);
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}
:host([type=classic]) .labels .headline:hover .custom-icon {
  fill: #2C3133;
  fill: var(--davinci-color-text-on-background-3, #2C3133);
}
:host([type=classic]) .labels .headline:focus {
  color: var(--davinci-color-white, );
  background-color: #737F85;
  background-color: var(--davinci-color-text-lighter, #737F85);
}
:host([type=classic]) .labels .headline[selected] {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text-on-background, #2C3133);
}
:host([type=classic]) .labels .headline[selected] .custom-icon {
  fill: #2C3133;
  fill: var(--davinci-color-text-on-background, #2C3133);
}
:host([type=classic]) .labels .headline[disabled] {
  pointer-events: none;
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([type=classic]) .labels .headline[disabled] .custom-icon {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([type=classic]) .labels .headline[disabled] .close {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
